export enum UserProvider {
  EMAIL = 'EMAIL',
}
